<template>
  <v-form @submit.prevent ref="form">
    <say-form :doc="doc">
      <v-btn class="mt-5" color="amber" @click="onSubmit">Submit</v-btn>
    </say-form>
  </v-form>
</template>

<script>
// @ is an alias to /src
import SayForm from "@/views/user/exercises/say/SayForm";
import { mapState } from "vuex";

export default {
  name: "RowAdd",
  components: {
    SayForm,
  },
  props: {
    doc: Object,
  },
  data() {
    return {
      valid: true,
    };
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    onSubmit() {
      this.$emit("addCommit", this.doc);
    },
  },
};
</script>
